export default __webpack_public_path__ + "static/media/014-cctv.1ce84a45.svg";